import { $api } from "../generated/client";

export default function useShopifyShopLocations(shopId: string) {
  return $api.useQuery("get", "/shops/{shopId}/active-locations", {
    params: { path: { shopId } }
  });
}
